import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class VoucherService {
  constructor(private restService: RestService) {}

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('vouchers/list', val_params);
  }

  sendVoucher(data: any) {
    return this.restService.save('vouchers/sendvoucher', data);
  }

  saveVoucherBilling(data: any) {
    return this.restService.save('vouchers/save_voucher_billing', data);
  }

  cancelledVoucher(data: any) {
    return this.restService.save('vouchers/cancelledvoucher', data);
  }

  getUrlDownloadXml(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('vouchers/url_download_xml', val_params);
  }
}
